import styled from 'styled-components'

import { DecidedCreatorStatus } from '../types'

// NOTE(BRAND-9295): These colour values reuse the existing approve/reject
// tokens already established in AgentSourcedCreatorRow.styled.ts and
// Header.styled.ts. No net-new design tokens were introduced. Flag for
// design review if the pill ever needs bespoke values.
interface IPillTone {
  bg: string
  fg: string
  border: string
}

const APPROVED_TONE: IPillTone = {
  bg: 'rgba(237, 252, 238, 0.9)',
  fg: '#01D36D',
  border: 'rgba(1, 211, 109, 0.3)',
}

// Keyed on the full status union so a new BE status fails the build here rather
// than silently rendering an undefined colour. `ready_for_shortlist` shares the
// approved tone by reference — the creator IS approved, they have simply moved a
// step further down the funnel (BRAND-9587).
const STATUS_TONE: Record<DecidedCreatorStatus, IPillTone> = {
  approved: APPROVED_TONE,
  ready_for_shortlist: APPROVED_TONE,
  rejected: {
    bg: 'rgba(255, 241, 241, 0.9)',
    fg: '#FC5151',
    border: 'rgba(252, 81, 81, 0.3)',
  },
}

export const PillRoot = styled.div<{
  status: DecidedCreatorStatus
}>`
  display: inline-flex;
  align-items: center;
  height: 2.5rem;
  border-radius: 1.25rem;
  overflow: hidden;
  font-family: Rubik, verdana, sans-serif;
  font-size: 0.8125rem;
  font-weight: 500;
  background: ${({ status }) => STATUS_TONE[status].bg};
  color: ${({ status }) => STATUS_TONE[status].fg};
  border: 0.0625rem solid ${({ status }) => STATUS_TONE[status].border};
`

export const StatusLabel = styled.span`
  flex-grow: 1;
  text-align: center;
  padding: 0 0.875rem;
  white-space: nowrap;
`

export const PillUndoButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 100%;
  padding: 0;
  border: none;
  border-left: 0.0625rem solid currentcolor;
  background: transparent;
  color: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
  opacity: 0.7;

  &:hover,
  &:focus-visible {
    opacity: 1;
  }

  &:focus-visible {
    outline: 0.125rem solid currentcolor;
    outline-offset: 0.125rem;
  }
`
